import { useTranslation } from "next-i18next";
import Image from "next/image";
import { useEffect } from "react";

const WhatIsCorporateEmail = () => {
    const { t } = useTranslation(["common", "homepage", "email"]);

    useEffect(() => {
        const handleScroll = () => {
            const targetElement = document.querySelector(".animate-on-scroll");
            if (targetElement) {
                const rect = targetElement.getBoundingClientRect();
                const isInViewport = rect.top < window.innerHeight && rect.bottom >= 0;

                if (isInViewport) {
                    targetElement.classList.add("visible");
                }
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <div className="container py-10 mx-auto lg:py-20">
            <div className="pb-10 lg:pb-0">
                <h2 className="relative px-2 pt-8 pb-4 text-3xl font-semibold text-titleColor lg:text-center lg:text-4xl text-after-shadow-email3">{t("email:whatIsCorporateEmail")}</h2>
                <div className="mx-2 text-sm text-textGray lg:text-base lg:text-center lg:pb-20" dangerouslySetInnerHTML={{ __html: t("email:whatIsCorporateEmailDesc") }}></div>
            </div>

            <div className="grid px-2 mx-auto lg:grid-cols-2">

                <div className="relative hidden lg:block">
                    <div className="absolute z-10 animate-on-scroll">
                        <Image src={"/whatIsCorporateEmail2.svg"} width={401} height={489} alt={t("email:whatIsCorporateEmail")} title={t("email:whatIsCorporateEmail")} />
                    </div>
                    <div>
                        <Image src={"/whatIsCorporateEmail1.svg"} width={340} height={618} alt={t("email:whatIsCorporateEmail")} title={t("email:whatIsCorporateEmail")} />
                    </div>
                </div>
                <div className="block pb-10 lg:hidden lg:pb-0">
                    <Image src={"/whatIsCorporateEmail.svg"} width={479} height={618} alt={t("email:whatIsCorporateEmail")} title={t("email:whatIsCorporateEmail")} />
                </div>
                <div className="space-y-6 lg:space-y-12">
                    <div className="space-y-2.5 ">
                        <h3 className="text-3xl font-bold text-titleColor">{t("email:corporateEmailAdvantages")}</h3>
                        <div className="text-sm font-medium text-textGray lg:text-base" dangerouslySetInnerHTML={{ __html: t("email:corporateEmailAdvantagesDesc") }}></div>
                    </div>

                    <div className="">
                        <h4 className="text-lg font-bold text-titleColor">{t("email:secureCommunication")}</h4>
                        <p className="text-sm font-medium text-textGray lg:text-base">{t("email:secureCommunicationDesc")}</p>
                    </div>

                    <div className="">
                        <h4 className="text-lg font-bold text-titleColor">{t("email:backupAndDataProtection")}</h4>
                        <p className="text-sm font-medium text-textGray lg:text-base">{t("email:backupAndDataProtectionDesc")}</p>
                    </div>

                    <div className="">
                        <h4 className="text-lg font-bold text-titleColor">{t("email:customizableStructure")}</h4>
                        <p className="text-sm font-medium text-textGray lg:text-base">{t("email:customizableStructureDesc")}</p>
                    </div>

                    <div className="">
                        <h4 className="text-lg font-bold text-titleColor">{t("email:uninterruptedAccess")}</h4>
                        <p className="text-sm font-medium text-textGray lg:text-base">{t("email:uninterruptedAccessDesc")}</p>
                    </div>

                    <div className="">
                        <h4 className="text-lg font-bold text-titleColor">{t("email:professionalImage")}</h4>
                        <p className="text-sm font-medium text-textGray lg:text-base">{t("email:professionalImageDesc")}</p>
                    </div>

                    <div className="text-sm font-medium text-textGray lg:text-base" dangerouslySetInnerHTML={{ __html: t("email:corporateEmailAdvantagesDesc2") }}></div>
                </div>
            </div>
        </div>
    )
}

export default WhatIsCorporateEmail